import { UserType } from './endpoints/userApi';

export interface EntityHistory<T> {
  id: number;
  date: string;
  userName: string;
  userEmail: string;
  userType: UserType | null;
  eventType: T;
  referenceId: number | null;
  referenceName: string | null;
  from: string | null;
  to: string | null;
}

export enum CompositionGroupHistoryEvent {
  CompositionGroupCreated = 1,
  CompositionGroupCreatedAsCopy = 2,
  CompositionGroupCopied = 3,
  CompositionGroupReplaced = 4,
  CompositionGroupArchived = 5,
  CompositionGroupRestored = 6,
  CompositionGroupRenamed = 7,
  CompositionGroupMarkedReady = 8,
  CompositionGroupMarkedNotReady = 9,
  CompositionGroupLayoutUpdated = 10,
  CompositionGroupLayoutAdded = 11,
  CompositionGroupLayoutRemoved = 12,
  CompositionGroupCreatedByAi = 13,
  CompositionGroupArtworkUpdated = 14,
  CompositionGroupArtworkAdded = 15,
  CompositionGroupArtworkRemoved = 16,
}

export enum CompositionHistoryEvent {
  CompositionCreated = 100,
  CompositionCreatedAsCopy = 101,
  CompositionCopied = 102,
  CompositionArchived = 103,
  CompositionRestored = 104,
  CompositionRenamed = 105,
}

export enum SampleHistoryEvent {
  SampleCreated = 201,
  SampleMarkedAsLost = 202,
  SampleAddedToTransportRequest = 203,
  SampleDispatchedWithShipment = 204,
  SampleUnpackedFromShipment = 205,
  SampleMarkedAsReceived = 206,
  SampleCancelledWithProductApproval = 207,
  SampleRejectedWithProductApproval = 208,
  SampleApprovedWithProductApproval = 209,
  SampleSentWithUnknownShipment = 210,
  SampleReceivedWithUnknownShipment = 211,
  SampleLostInShipment = 212,
  SampleRemovedFromTransportRequest = 213,
  SampleInactiveWithArchivedVersion = 214,
  SampleChangedOwner = 215,
  SampleSetOnHold = 216,
}

export enum InquiryHistoryEvent {
  InquiryCreated = 401,
  InquiryUpdated = 402,
  InquiryArchived = 403,
  InquiryRestored = 404,
  InquiryCopied = 405,
  InquiryAccepted = 406,
  InquiryUnaccepted = 407,
}

export type UnifiedHistoryEvents = typeof CompositionGroupHistoryEvent &
  typeof CompositionHistoryEvent &
  typeof SampleHistoryEvent &
  typeof InquiryHistoryEvent;

export type SharedHistoryEvents =
  | CompositionGroupHistoryEvent
  | CompositionHistoryEvent
  | SampleHistoryEvent
  | InquiryHistoryEvent;

export const unifiedHistoryKeys = {
  ...SampleHistoryEvent,
  ...CompositionGroupHistoryEvent,
  ...CompositionHistoryEvent,
  ...InquiryHistoryEvent,
};
